import useMutation from "src/hooks/useMutation";

function useOrderTrackingStatus(id) {
  const path = id ? `/api/v1/orders/${id}/tracking-status` : `/api/v1/orders/orderId/tracking-status`;
  return useMutation({
    path: path,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: [`/api/v1/orders`, `/api/v1/orders/count`],
      shouldRevalidate: true,
    },
  });
}

export default useOrderTrackingStatus;
